import { MoreVert as MoreVertIcon } from '@mui/icons-material';

const MoreDots = (): JSX.Element => <MoreVertIcon fontSize="inherit" />;
export default MoreDots;
